module.exports = __webpack_public_path__ + "img/964e40b005724165b8cf772355796c8c.bfb030c2.jpeg";